import {alias, createModelSchema, raw, deserialize, serialize, SKIP, custom, list} from "serializr";
import {Schema} from "@/common/Schema";
import {BaseObject} from "@/common/BaseObject";

export class MergeHistoryModel extends BaseObject {

    static schema() {
        return custom(
            (v) => {
                return v && !v.empty() ? serialize(MergeHistoryModel, v) : SKIP;
            },
            (v) => {
                return deserialize(MergeHistoryModel, v);
            }
        );
    }

    constructor() {
        super();
        this._data = [];
        this._date = null;
    }

    get data() {return this._data;}
    set data(value) {this._data = value;}

    get date() {return this._date;}
    set date(value) {this._date = value;}

    copy() {
        return super.copy();
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new MergeHistoryModel());
        } else if (target instanceof MergeHistoryModel) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

createModelSchema(MergeHistoryModel, {
    _data:alias("data", list(raw())),
    _date: alias("date", Schema.primitive()),
});